import {useContext, useState, useCallback} from 'react';
import {BaSeDialogContext} from "@base/react";
import xlsService from '../../services/xlsService';
import useModalStatus from "./useModalStatus";

interface ExcelExportOptions {
    handleDataCallback: () => Promise<any>;
    filename: string;
    colorLoading?: string;
    isCsv?: boolean;
}

interface ExcelExportResult {
    executeDownload: () => void;
    downloading: boolean;
}

interface ExcelExportOptions {
    handleDataCallback: () => Promise<any>;
    filename: string;
    colorLoading?: string;
    isCsv?: boolean;
}

interface ExcelExportResult {
    executeDownload: () => void;
    downloading: boolean;
}

const useExcelExport = ({
                            handleDataCallback,
                            filename,
                            isCsv = false,
                        }: ExcelExportOptions): ExcelExportResult => {

    const {showModal} = useContext(BaSeDialogContext);

    const [downloading, setDownloading] = useState<boolean>(false);

    const {handleModalStatus} = useModalStatus(); // Use seu novo hook aqui

    const executeDownload = useCallback(async () => {
        try {
            setDownloading(true);
            const response = await handleDataCallback();
            const responseContent = response?.content ?? response;
            if (responseContent) {
                const file = !!isCsv
                    ? xlsService.xlsDownloadCsv(responseContent, filename, () => setDownloading(false))
                    : xlsService.xlsDownload(responseContent, filename, () => setDownloading(false));

                file.catch(() => {
                    setDownloading(false);
                    handleModalStatus({
                        type: 'error',
                        msgOnError: 'Houve um erro ao apresentar o relatório. Tente novamente mais tarde.',
                        onCloseModal: () => setDownloading(false),
                        showModal,
                    });
                });
            } else {
                setDownloading(false);
            }
        } catch (e) {
            setDownloading(false);
            handleModalStatus({
                type: 'error',
                msgOnError: 'Houve um erro ao apresentar o relatório. Tente novamente mais tarde.',
                onCloseModal: () => setDownloading(false),
                showModal,
            });
        }
    }, [handleDataCallback, filename, isCsv, showModal, handleModalStatus]);

    return {executeDownload, downloading};
};

export default useExcelExport;